import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Box, List, ListItem, IconButton, Typography, Divider, CircularProgress, Tooltip, Button, TextField,MenuItem, FormGroup } from "@mui/material";
// import { Radio, RadioGroup, FormControlLabel } from '@mui/material';
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import DownloadIcon from "@mui/icons-material/Download"; 
import EditIcon from '@mui/icons-material/Edit';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { styled } from "@mui/material/styles";
import { FormControlLabel, Checkbox } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { tagActions } from "../../actions/tag.action";

import { useNavigate } from "react-router-dom";
import { currencyFormat, changeDateFormat, escapeHtml } from "../../helpers/common";
import './Search.css'
//Components
// import Header from "../../Components/Header";
// import ArchiveBudget from "../../Components/Budget";
import axiosInstance from "../../interceptor/interceptor";
// Package for datepicker
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// import Footer from '../../Components/Footer';
const Demo = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
  }));
  

const Search = () => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [totalExpense, setTotalExpense] = React.useState(0);
    const [totalIncome, setTotalIncome] = React.useState(0);
    const [expenseList, setExpenseList] = React.useState([]);
    const [incomeList, setIncomeList] = React.useState([]);
    const tagList = useSelector((state) => state.tagReducer.tags);
    const accountList = useSelector((state) => state.accountReducer.accounts);
    const activeAccount = accountList.filter(item=> item.is_archived==0);

    const currency = localStorage.getItem('currency');
    const minDate = dayjs().startOf('month').add(1, 'day').set('year', 2000).format('YYYY-MM-DD HH:mm:ss');
    const maxDate = dayjs().startOf('month').add(1, 'day').set('year', 2100).format('YYYY-MM-DD HH:mm:ss');
    const startDate = useSelector((state) => state.varsReducer.startDate);
    const endDate = useSelector((state) => state.varsReducer.endDate);
    const [renderCounter, setrenderCounter] = React.useState(1);
    const [showSearchForm, setShowSearchForm] = React.useState(true);
    // const selectedCheckboxes = new Set();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [inputField, setInputField] = React.useState({
        user_id: localStorage.getItem("user_text_obj_data1"),
        tag_id: [],
        account_id: [],
        sort: "ASC",
        query: "",
        from:startDate,
        to: endDate,
        submitted:false,
      });

    const inputsHandler = (e) => {
      setInputField({ ...inputField, [e.target.name]: e.target.value });
    }
    
    const inputsHandler2 = (newVal) => {
      setInputField({ ...inputField, from: changeDateFormat(newVal) });
    };
    const inputsHandler3 = (newVal) => {
      setInputField({ ...inputField, to: changeDateFormat(newVal) });
    };
    const toggleCheckbox = (event) => {
      const label = event.target.value;
      if(event.target.name === "tag_id"){
        const selectedCheckboxes = new Set(inputField.tag_id);
        if (selectedCheckboxes.has(label)) {
          selectedCheckboxes.delete(label);
        } else {
          selectedCheckboxes.add(label);
        }
        setInputField({ ...inputField, tag_id: Array.from(selectedCheckboxes) });
      }
      if(event.target.name === "account_id"){
        const selectedCheckboxes = new Set(inputField.account_id);
        if (selectedCheckboxes.has(label)) {
          selectedCheckboxes.delete(label);
        } else {
          selectedCheckboxes.add(label);
        }
        setInputField({ ...inputField, account_id: Array.from(selectedCheckboxes) });
      }
    }
  
    function moveBack(){
        navigate("/web");
      }

      useEffect(() => {
        fetchTags();
      }, []);

      function showHideBtn(){
        setShowSearchForm(!showSearchForm);
      }
      // Fetch tags
      function fetchTags() {
        try {
          const user_id = localStorage.getItem("user_text_obj_data1");
          dispatch(tagActions.fetchTags({ user_id: user_id }));
        } catch (e) {
          alert(e);
        }
      }

    const handleSearch = async () => {
      try {
          setIsLoading(true);
          setInputField({ ...inputField, submitted: true });
          const res = await axiosInstance.get(
            `api?method=search_transaction&sort=${inputField.sort}&user_id=${encodeURIComponent(inputField.user_id)}&query=${inputField.query}&tag_id=${inputField.tag_id}&account_id=${inputField.account_id}&from=${inputField.from}&to=${inputField.to}`
          );
          const d = renderCounter+1;
          setrenderCounter(d);
          const expense = res.data.expense;
          const income = res.data.income;
          if(expense.length > 0 || income.length > 0){
            setShowSearchForm(false);
          }
          setExpenseList(expense);
          setIncomeList(income);
          const totalExpense = expense.reduce((accumulator, currentObj) => accumulator + currentObj.amount , 0);
          const totalIncome = income.reduce((accumulator, currentObj) => accumulator + currentObj.amount , 0);
          setTotalExpense(totalExpense);
          setTotalIncome(totalIncome);
          setIsLoading(false);
      } catch (e) {
        setExpenseList([]);
        setIncomeList([]);
        toast.info(`Error: ${e.response && e.response.data && e.response.data.message ? e.response.data.message: e}`, { type: "error" });
        // if(e.response && e.response.data && e.response.data.message){
        //   toast.info(`Error: ${e.response.data.message}`, { type: "error" });
        // }
        // else {
        //   toast.info(`Error: ${e}`, { type: "error" });
        // }
      }
    };

    // downladPDF
    const downloadPDF = () => {
      if (window.confirm("Sure to download the PDF?")) {
        var doc = new jsPDF();
        doc.text('MoneyTrek - Budget & Expenses', 15, 20);
        const columns = ["Date", "Category", "Notes","Amount"];
        const rows = [];
        // Expense List
        let itemRow = [];
        let totalAmount = 0;
        itemRow = ['Expense', '', '',''];
        rows.push(itemRow);

        expenseList.forEach((item)=>{
          // Define the table columns and rows
          totalAmount = totalAmount + item.amount;
          const tempDate = new Date(item.transaction_date).getDate() +" " + new Date( item.transaction_date ).toLocaleString("default", { month: "short" }) +" "+ new Date(item.transaction_date).getFullYear();
          itemRow = [tempDate, escapeHtml(item.name), escapeHtml(item.note), item.amount.toLocaleString('en-IN')];
          rows.push(itemRow);
        })
        totalAmount = `Rs ${totalAmount.toLocaleString('en-IN')}`;
        itemRow = ['Total Expense', '','',totalAmount ,''];
        rows.push(itemRow);
        itemRow = ['', '', '',''];
        rows.push(itemRow);
        // Income List
        let itemRow2 = [];
        let totalIncome = 0;
        itemRow2 = ['Income', '', '',''];
        rows.push(itemRow2);
        incomeList.forEach((item)=>{
          // Define the table columns and rows
          totalIncome += item.amount; //totalIncome + item.amount; {currencyFormat(data.amount, currency)}
          const tempDate = new Date(item.transaction_date).getDate() +" " + new Date( item.transaction_date ).toLocaleString("default", { month: "short" }) +" "+ new Date(item.transaction_date).getFullYear();
          itemRow2 = [tempDate, escapeHtml(item.name), escapeHtml(item.note), item.amount.toLocaleString('en-IN')];
          rows.push(itemRow2);
        })
        // rows.push(itemRow2);
        totalIncome = `Rs ${totalIncome.toLocaleString('en-IN')}`;
        itemRow2 = ['Total Income', '','',totalIncome ,''];
        rows.push(itemRow2);
        // Set the table options
        const options = {
        startY: 30, // Vertical position to start the table (in mm)
        };
        // Generate the table
        doc.autoTable(columns, rows, options);
        doc.save('moneytrek-expenses.pdf');
      }
      
    }


  return (
    <>
    {/* <ToastContainer /> */}
      <Grid container>
        <Grid item xs={12} style={{ marginTop: "0px", height: "90vh" }}>
        <Box className="tabpanel-data">
      <Box sx={{ width: "100%" }}>
        <Grid container>
          <Grid item xs={12} md={12}>
            <h3 style={{ textAlign: "center" }}>
            <Button className="top-nav-btn" variant="outlined">
                <KeyboardBackspaceRoundedIcon
                  onClick={moveBack}
                  style={{ cursor: "pointer", float: 'left',marginLeft: '10px !important' }}
                />
            </Button>Search
            <Box style={{float:'right', cursor:'pointer'}}>
              {showSearchForm === false && expenseList.length > 0  ? (
                  <ExpandMoreIcon onClick={showHideBtn} fontSize="large" />
              ): (
                expenseList.length > 0 && <ExpandLessIcon onClick={showHideBtn} fontSize="large"/>
              )}
            </Box>
            </h3>
            <Demo style={{ minHeight: "500px" }}>
              {/* {showSearchForm ?( */}
                <form className="tag-form" style={{width:'100%', display: showSearchForm ? "block" : "none"}}>

                <Grid container className="tag-form-container" key="tyuioiuy">
                    {/* <Box style={{fontWeight:'500', padding:'10px 0px'}}>{inputField.tag_id && inputField.tag_id!=""  ? (<>Update</>):(<>Create New</>)} Tag</Box> */}
                    <Grid item xs={6} style={{padding:'5px'}}>
                        <TextField
                            value={inputField.query}
                            onChange={inputsHandler}
                            type="text"
                            label="Type here to search"
                            variant="outlined"
                            name="query"
                            maxLength={20}
                        />
                    </Grid>
                    <Grid item xs={6} style={{padding:'5px'}}>
                        <TextField
                        id="select type"
                        select
                        label="Sort By"
                        name="sort"
                        defaultValue={inputField.sort}
                        onChange={inputsHandler}
                        >
                            <MenuItem key='asc' value='ASC' >Ascending</MenuItem>
                            <MenuItem key='desc' value='DESC' >Descending</MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item xs={6}  style={{padding:'5px'}} key="fghjkljhgf">
                      <LocalizationProvider dateAdapter={AdapterDayjs} key={`1676`}>
                        <MobileDatePicker
                        key='datepicker1'
                          label="From"
                          value={inputField.from}
                          minDate ={minDate}
                          maxDate = {maxDate}
                          onChange={(newValue) => {
                            inputsHandler2(newValue);
                          }}
                          renderInput={(params) => <TextField {...params} key="fld1" />}
                        />
                      </LocalizationProvider>
                    </Grid>
                     <Grid item xs={6}  style={{padding:'5px'}} key={'fdghjk'}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} key={`277`}>
                        <MobileDatePicker
                          key='datepicker2'
                          label="To"
                          value={inputField.to}
                          minDate ={minDate}
                          maxDate = {maxDate}
                          onChange={(newValue) => {
                            inputsHandler3(newValue);
                          }}
                          renderInput={(params) => <TextField {...params} key="fld2" />}
                        />
                      </LocalizationProvider>
                    </Grid>

                    {/* { tagList.length > 0 && <Grid item xs={12} style={{margin:'5px'}}>
                      Tags: &nbsp;
                    {tagList.length > 0 ? tagList.map((data, index) => (
                        <React.Fragment key={index}>
                        <FormControlLabel
                        className="btn-check"
                        control={<Checkbox defaultChecked={inputField.tag_id.includes(data.tag_id)} onChange={e => toggleCheckbox(data.tag_id)} />}
                        label={data.name}
                        />
                      
                    </React.Fragment>
                    )) : (
                    <></>
                    )}
                    </Grid>} */}

                    { tagList.length > 0 && <Grid item xs={12} style={{margin:'5px'}}>
                      Tags: &nbsp;
                    {tagList.length > 0 ? tagList.map((data, index) => (
                      <span key={index} className="checkbox-span">
                      <input type="checkbox" id={'account'+index} name="tag_id" value={data.tag_id} onChange={toggleCheckbox} />
                      <label className="radio-label" htmlFor={'account'+index}>{data.name}</label>
                    </span>
                    )) : (
                    <></>
                    )}
                    </Grid>}
                    
                     { activeAccount.length > 0 && <Grid item xs={12} style={{margin:'5px'}}>
                      Accounts: &nbsp;
                    {activeAccount.length > 0 ? activeAccount.map((account, index) => (
                      <span key={index} className="checkbox-span">
                      <input type="checkbox" id={'account2'+index} name="account_id" value={account.account_id} onChange={toggleCheckbox} />
                      <label className="radio-label" htmlFor={'account2'+index}>{account.name}</label>
                    </span>
                    )) : (
                    <></>
                    )}
                    </Grid>} 
                    <Grid item xs={12}>
                      <Button variant="outlined" onClick={handleSearch} className="fl-rt">Search</Button>
                    </Grid>

                    
                    
                </Grid>
            </form>
          {/* ):(
          // <></>
          // )}*/}
                {/* Expense List */}
                {expenseList ? (
                <List>
                  {expenseList.length > 0 ? (
                    <>
                      <Box component="div" m="{1}" className="default-budget">
                        {expenseList.length + incomeList.length} records found
                        <Button style={{border: '2px solid cadetblue', borderRadius: '20px', padding: '2px', float: 'right', marginTop:'-3px'}} onClick={downloadPDF}>
                          <DownloadIcon fontSize="small"  style={{color:"cadetblue"}}/>
                        </Button>
                      </Box>
                      <span style={{fontSize:'12px',paddingLeft: '10px'}}><strong>Expenses</strong></span>
                      </>
                    ): (
                      inputField.submitted  === true && <Box component="span" m="{1}" className="default-budget" style={{display:'flex'}}>
                      {isLoading === true ? ( <Box>Searching...</Box> ):( <Box>0 record found</Box> )}
                  </Box>
                    )}
                  {expenseList.length > 0 ? expenseList.map((data, index) => (
                    <div key={index}>
                      <ListItem style={{padding:'8px'}}>
                        <div className="search-list-item" style={{fontSize:'12px'}}>
                          <Grid container>
                            <Grid item xs={3}>{index+1}. {new Date(data.transaction_date).getDate() +
                                  " " +
                                  new Date(
                                    data.transaction_date
                                  ).toLocaleString("default", {
                                    month: "short",
                                  })}{" "}
                                {new Date(data.transaction_date).getFullYear()}{" "}</Grid>
                            <Grid item xs={7}>{data.note} <strong>({escapeHtml(data.name)})</strong> </Grid>
                            <Grid item xs={2} style={{textAlign:'right'}}>{currencyFormat(data.amount, currency)}</Grid>
                               
                          </Grid>
                         

                        </div>
                      </ListItem>
                      <Divider
                        sx={{
                          marginLeft: "5%",
                          marginRight: "5%",
                        }}
                      />
                    </div>
                  )): (
                    <>
                    {/* <Box component="span" m="{1}" className="default-budget" style={{display:'flex'}}>
                  No Data Available
                    </Box> */}
                    </>
                  )}
                  {expenseList.length > 0 && <ListItem style={{padding:'8px'}}>
                        <div className="search-list-item" style={{fontSize:'12px'}}>
                          <Grid container>
                            <Grid item xs={3}><strong>Total</strong></Grid>
                            <Grid item xs={7}></Grid>
                            <Grid item xs={2} style={{textAlign:'right', fontWeight:'600'}}>{currencyFormat(totalExpense, currency)}</Grid>
                               
                          </Grid>
                         

                        </div>
                      </ListItem>}
                      <ListItem style={{borderTop: '2px solid grey'}}></ListItem>

                    {/* Income List */}
                    {incomeList.length > 0 && <span style={{fontSize:'12px',paddingLeft: '10px'}}><strong>Income</strong></span>}
                    {incomeList.length > 0 ? incomeList.map((data, index) => (
                    <div key={index}>
                      <ListItem style={{padding:'8px'}}>
                        <div className="search-list-item" style={{fontSize:'12px'}}>
                          <Grid container>
                            <Grid item xs={3}>{index+1}. {new Date(data.transaction_date).getDate() +
                                  " " +
                                  new Date(
                                    data.transaction_date
                                  ).toLocaleString("default", {
                                    month: "short",
                                  })}{" "}
                                {new Date(data.transaction_date).getFullYear()}{" "}</Grid>
                            <Grid item xs={7}>{data.note} <strong>({escapeHtml(data.name)})</strong> </Grid>
                            <Grid item xs={2} style={{textAlign:'right'}}>{currencyFormat(data.amount, currency)}</Grid>
                               
                          </Grid>
                         

                        </div>
                      </ListItem>
                      <Divider
                        sx={{
                          marginLeft: "5%",
                          marginRight: "5%",
                        }}
                      />
                    </div>
                  )): (
                    <>
                    {/* <Box component="span" m="{1}" className="default-budget" style={{display:'flex'}}>
                  No Data Available
                    </Box> */}
                    </>
                  )}
                  {incomeList.length > 0 && <ListItem style={{padding:'8px'}}>
                      <div className="search-list-item" style={{fontSize:'12px'}}>
                        <Grid container>
                          <Grid item xs={3}><strong>Total</strong></Grid>
                          <Grid item xs={7}></Grid>
                          <Grid item xs={2} style={{textAlign:'right', fontWeight:'600'}}>{currencyFormat(totalIncome, currency)}</Grid>
                              
                        </Grid>
                      </div>
                      </ListItem>}
                      
                </List>
              ) : (
                <>
                  <div id="overlay">
                    <div className="loader">
                      <CircularProgress />
                    </div>
                  </div>
                </>
              )}
            </Demo>
          </Grid>
        </Grid>
      </Box>
    </Box>
        </Grid>
      </Grid>

    </>
  );
};

export default Search;
